/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgUserUpdateGroup
 */
export interface OrgUserUpdateGroup {
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateGroup
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateGroup
     */
    auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateGroup
     */
    group_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateGroup
     */
    organization_azure_id: string;
}

/**
 * Check if a given object implements the OrgUserUpdateGroup interface.
 */
export function instanceOfOrgUserUpdateGroup(value: object): value is OrgUserUpdateGroup {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    if (!('group_name' in value) || value['group_name'] === undefined) return false;
    if (!('organization_azure_id' in value) || value['organization_azure_id'] === undefined) return false;
    return true;
}

export function OrgUserUpdateGroupFromJSON(json: any): OrgUserUpdateGroup {
    return OrgUserUpdateGroupFromJSONTyped(json, false);
}

export function OrgUserUpdateGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgUserUpdateGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'auth_id': json['auth_id'],
        'group_name': json['group_name'],
        'organization_azure_id': json['organization_azure_id'],
    };
}

export function OrgUserUpdateGroupToJSON(json: any): OrgUserUpdateGroup {
    return OrgUserUpdateGroupToJSONTyped(json, false);
}

export function OrgUserUpdateGroupToJSONTyped(value?: OrgUserUpdateGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'auth_id': value['auth_id'],
        'group_name': value['group_name'],
        'organization_azure_id': value['organization_azure_id'],
    };
}

